import React from 'react'

import { ComboboxItem, SelectPropertiesInterface, Stack, Text } from '@affstore-ds/uikit'

export const renderAdvertiserModelItem: SelectPropertiesInterface['renderOption'] = (properties) => {
  const { label, description, disabled } = properties as ComboboxItem & { description?: string }

  return (
    <Stack gap={0}>
      <Text colorVariant={disabled ? 'greyIron.9' : 'greyIron.20'} elementSize="s" elementVariant="default">
        {label}
      </Text>
      {description && (
        <Text colorVariant="raspberry.12" elementSize="s" elementVariant="default">
          {description}
        </Text>
      )}
    </Stack>
  )
}
